import { motion } from "motion/react";
import { useAutoScrollSlider, AutoScrollSlide } from "@/features/shop";
import type { AutoScrollSliderProps } from "@/features/shop/types/autoScrollSlider.types";

export const AutoScrollSlider = ({ cards, scrollSpeed, offsetX = 0 }: AutoScrollSliderProps) => {
  const {
    containerRef,
    duplicatedItems,
    x,
    handleMouseEnter,
    handleMouseLeave,
    handleDragStart,
    handleDrag,
    handleDragEnd,
    isDragging,
  } = useAutoScrollSlider(cards, scrollSpeed);

  return (
    <div
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      style={{ transform: `translateX(${offsetX}px)` }}
      className="my-2 py-2 overflow-x-hidden"
    >
      <motion.div
        ref={containerRef}
        className="flex gap-4 cursor-grab active:cursor-grabbing"
        style={{ x }}
        drag="x"
        dragElastic={0}
        dragMomentum={false}
        onDragStart={handleDragStart}
        onDrag={handleDrag}
        onDragEnd={handleDragEnd}
      >
        {duplicatedItems.map((card, index) => (
          <div key={`${card.id}-${index}`} className="flex-shrink-0">
            <AutoScrollSlide
              title={card.title}
              subtitle={card.subtitle}
              backgroundColor={card.backgroundColor}
              image={card.image}
              imageBackground={card.imageBackground}
              link={card.link}
              isDragging={isDragging}
              isClone={index >= cards.length}
            />
          </div>
        ))}
      </motion.div>
    </div>
  );
};
